<template>
  <VLayout :title="$t('orders_history.orders_history')">
    <p class="user-help">{{ $t("orders_history.help") }}</p>
    <OrdersList class="mt-5" />
    <VButtonGroup />
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import OrdersList from "@/components/OrdersList";
import VButtonGroup from "@/components/VButtonGroup";

export default {
  components: {
    VLayout,
    OrdersList,
    VButtonGroup,
  },
  fallbackI18n: {
    messages: {
      und: {
        orders_history: {
          orders_history: "Orders history",
          help:
            "Here all the orders that have been made since your account was created are listed.",
        },
      },
    },
  },
};
</script>

